export class AddMatchedLeadsProductHiringZips {
    zips: string[];
    radius: number;
}